module.exports = __webpack_public_path__ + "static/media/C2QB_green_btn_lg_hover.c44cb194.png";